<template>
  <div v-if="reviewDataWithImages?.length && !config.showGallery?.hidden">
    <div class="fe-mb-base sm:fe-spacing-horizontal">
      <div class="fe-text-heading-xxs lg:fe-text-heading-xs">
        Customer photos
        <span v-if="totalImageCount">({{ totalImageCount }})</span>
      </div>
    </div>

    <div class="sm:fe-mb-s">
      <ImageListSlider
        :reviews="reviewDataWithImages"
        @click="openGalleryImageModal"
        @clickmore="openGalleryImageModal"
        sliderClass="sm:fe-spacing-horizontal"
      />
    </div>
  </div>
</template>

<script>
  import ImageListSlider from "@/components/DesignSystem/ImageListSlider/ImageListSlider.vue"
  import GalleryImageModal from "./GalleryImageModal.vue"
  import GalleryContentModal from "./GalleryContentModal.vue"
  import { modalMixin } from "@/mixins/modalMixin"

  export default {
    name: "GalleryList",
    components: {
      ImageListSlider,
    },
    mixins: [modalMixin],
    inject: ["globalState"],
    computed: {
      reviewDataWithImages() {
        return this.globalState.reviewsWithImages
      },
      totalImageCount() {
        return this.globalState.imageCount || 0
      },
      config() {
        return this.globalState.widgetConfig?.layout
      },
    },
    methods: {
      openGalleryImageModal() {
        this.openModal(GalleryImageModal)
      },
      openGalleryContentModal(payload) {
        if (payload) {
          this.openModal(GalleryContentModal, {
            currentReview: payload.review,
            currentImageId: payload.imageId,
          })
        }
      },
    },
  }
</script>
